import styled from '@emotion/styled'

export default styled.a`
  text-decoration: underline;
  color: #0161ab;
`
